import { createSelector } from 'reselect';
import { TimeUnit } from '@mews/enums';
import { TimeUnitUtils } from '@mews/framework';
import { getAvailabilityBlock } from '../ducks/availabilityBlocks';
import { getServiceTimeUnit } from '../ducks/services';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from './session/enterprise';

export const getAvailabilityBlockViewEndUtc = createSelector(
    (state) => state,
    getAvailabilityBlock,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (applicationState, availabilityBlock, timezone: string) => {
        const endUtc = availabilityBlock?.endUtc;
        return (
            endUtc &&
            TimeUnitUtils.addTimeUnitToUtc(
                endUtc,
                timezone,
                getServiceTimeUnit(applicationState, { id: availabilityBlock.serviceId }) ?? TimeUnit.Day,
                1
            )
        );
    }
);
